module.exports = __webpack_public_path__ + "img/stripe.286d0d43.svg";